<ng-container *transloco="let t">
    <div class="relative flex flex-col md:w-140 -m-6">

        <!-- Dismiss button -->
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button
                [matDialogClose]="undefined"
                mat-icon-button>
                <mat-icon
                    [svgIcon]="'heroicons_outline:x-mark'"
                    class="text-secondary"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="flex flex-col sm:flex-row items-center sm:items-start p-8 pb-6 sm:pb-8">

            <!-- Icon -->
            <div
                class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600">
                <mat-icon
                    [svgIcon]="'heroicons_outline:key'"
                    class="text-current"></mat-icon>
            </div>

            <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

                <!-- Title -->
                <div class="text-xl leading-6 font-medium">
                    {{t('password-required-title')}}
                </div>

                <!-- Message -->
                <div class="text-secondary">
                    {{t('password-required-message')}}
                </div>

                <form
                    (ngSubmit)="onSubmit()"
                    [formGroup]="passwordForm"
                    class="grid grid-cols-1 items-start w-full pt-2"
                    id="passwordForm">

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full">
                        <input
                            [formControlName]="'password'"
                            autocomplete="current-password"
                            matInput
                            name="password"
                            type="password"
                            required>
                    </mat-form-field>
                </form>
            </div>

        </div>

        <!-- Actions -->
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">

            <!-- Confirm -->
            <button
                [color]="'primary'"
                [disabled]="passwordForm.get('password').value.length === 0"
                form="passwordForm"
                mat-flat-button
                type="submit">
                {{t('confirm')}}
            </button>

        </div>

    </div>
</ng-container>
